import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=289f7172&"
var script = {}
import style0 from "./Footer.vue?vue&type=style&index=0&id=289f7172&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports